import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { LMap,LTileLayer,LMarker,LGeoJson,LPopup,LCircleMarker } from 'vue2-leaflet';
import vSelect from 'vue-select';
import Multiselect from 'vue-multiselect';

Vue.component('multiselect',Multiselect)

Vue.component('search', require('./components/Search/Search').default);
Vue.component('search-index-map', require('./components/Search/SearchIndexMap').default);
Vue.component('range-slider', require('./components/Search/RangeSlider').default);
Vue.component('facet-filter', require('./components/Search/partials/FacetFilter').default);

Vue.component('filtered-search', require('./components/Search/FilteredSearch').default);
Vue.component('distributor-search-index', require('./components/Distributor/DistributorSearchIndex').default);
Vue.component('distributor-filtered-search', require('./components/Distributor/DistributorFilteredSearch').default);
Vue.component('user-profile-distributors', require('./components/Distributor/UserProfileDistributors').default);
Vue.component('profile-suggested-distributors', require('./components/Distributor/ProfileSurggestedDistributors').default);

Vue.component('surgeon-search-index', require('./components/Surgeon/SurgeonSearchIndex').default);
Vue.component('surgeon-filtered-search', require('./components/Surgeon/SurgeonFilteredSearch').default);
Vue.component('surgeon-cpt-codes', require('./components/Surgeon/SurgeonCptCodes').default);
Vue.component('surgeon-sunshine-summary', require('./components/Surgeon/SunshineSummary').default);
Vue.component('surgeon-sunshine-table', require('./components/Surgeon/SunshineTable').default);
Vue.component('surgeon-similarity', require('./components/Surgeon/Similarity').default);
Vue.component('user-profile-surgeons', require('./components/Surgeon/UserProfileSurgeons').default);
Vue.component('profile-suggested-surgeons', require('./components/Surgeon/ProfileSuggestedSurgeons').default);

Vue.component('facility-search-index', require('./components/Hospital/FacilitySearchIndex').default);
Vue.component('facility-filtered-search', require('./components/Hospital/FacilityFilteredSearch').default);
Vue.component('user-profile-facilities', require('./components/Hospital/UserProfileFacilities').default);
Vue.component('profile-suggested-facilities', require('./components/Hospital/ProfileSuggestedFacilities').default);

// Manufacturer
Vue.component('manufacturer-search-index', require('./components/Manufacturer/ManufacturerSearchIndex').default);
Vue.component('manufacturer-filtered-search', require('./components/Manufacturer/ManufacturerFilteredSearch').default);
Vue.component('manufacturer-edit', require('./components/Manufacturer/Edit').default);
Vue.component('manufacturer-sunshine-summary', require('./components/Manufacturer/SunshineSummary').default);
Vue.component('manufacturer-sunshine-table', require('./components/Manufacturer/SunshineTable').default);
Vue.component('manufacturer-create', require('./components/Manufacturer/Create').default);

Vue.component('news-search-index',require('./components/News/NewsSearchIndex').default);
Vue.component('news-post-index',require('./components/News/NewsPostIndex').default);

// Partials
Vue.component('breadcrumbs', require('./components/Partials/Breadcrumbs/Breadcrumbs').default);
Vue.component('error-alert', require('./components/Partials/Alerts/Error').default);
Vue.component('success-alert', require('./components/Partials/Alerts/Success').default);
Vue.component('action-buttons', require('./components/ProfileActionButtons/ProfileActionButtons').default);
Vue.component('request-profile-data-button', require('./components/ProfileActionButtons/RequestProfileDataButton').default);
Vue.component('request-profile-data-modal', require('./components/ProfileActionButtons/RequestProfileDataModal').default);
Vue.component('hidden-attribute-button', require('./components/ProfileActionButtons/HiddenAttributeButton').default);

// UI Components
Vue.component('top-nav', require('./components/UI/TopNav').default);
Vue.component('tabbed-content', require('./components/UI/TabbedContent').default);
Vue.component('ui-modal', require('./components/UI/Modal').default);
Vue.component('ui-delete-modal', require('./components/UI/DeleteModal').default);
Vue.component('ui-warning-modal', require('./components/UI/WarningModal').default);
Vue.component('data-table', require('./components/UI/VueDatatable').default);
Vue.component('inactive-panel', require('./components/UI/InactivePanel').default);
Vue.component('collapsible', require('./components/Search/partials/Collapsible').default);
Vue.component('tw-modal', require('./components/UI/TailwindModal').default);
Vue.component('hidden-tab', require('./components/UI/HiddenTab').default);

// Project
Vue.component('project-search-index', require('./components/Project/ProjectSearchIndex').default);
Vue.component('project-panel-by-account', require('./components/Project/PanelByAccount').default);

// Project Update
Vue.component('project-update-add-edit-project-modal', require('./components/ProjectUpdate/AddEditProjectModal').default);
Vue.component('project-update-add-general-modal', require('./components/ProjectUpdate/AddGeneralModal').default);
Vue.component('project-update-list', require('./components/ProjectUpdate/List').default);
Vue.component('project-update-list-modal', require('./components/ProjectUpdate/ListModal').default);
Vue.component('project-update-details-modal', require('./components/ProjectUpdate/DetailsModal').default);
Vue.component('project-update-panel-by-account', require('./components/ProjectUpdate/PanelByAccount').default);

// Dashboard
Vue.component('dashboard-page', require('./components/Dashboard/Page').default);
Vue.component('dashboard-page-head', require('./components/Dashboard/Page/Head').default);
Vue.component('dashboard-page-menu', require('./components/Dashboard/Page/Menu').default);
Vue.component('dashboard-page-info-bar', require('./components/Dashboard/Page/InfoBar').default);
Vue.component('dropdown-menu', require('./components/UI/DropDownMenu').default);
Vue.component('admin-dashboard', require('./components/Dashboard/AdminDashboard').default)

// Contacts
Vue.component('contact-show-page', require('./components/Contact/ShowPage').default);
Vue.component('contact-panel', require('./components/Contact/Panel').default);
Vue.component('contact-add-edit-form-modal', require('./components/Contact/AddEditFormModal').default);

// File
Vue.component('file-panel', require('./components/File/Panel').default);
Vue.component('file-upload-form-modal', require('./components/File/UploadFormModal').default);

// Messages and MessageThread
Vue.component(
    'message-thread-nav-widget',
    require('./components/Message/MessageThreadNavWidget').default
);

Vue.component(
    'message-thread-panel',
    require('./components/Message/MessageThreadPanel').default
);

Vue.component(
    'message-thread-add-form-modal',
    require('./components/Message/MessageThreadAddFormModal').default
);

Vue.component(
    'message-thread-index-page',
    require('./components/Message/MessageThreadIndexPage').default
);

// Notes
Vue.component('note-list', require('./components/Note/List').default);
Vue.component('note-add-edit-form-modal', require('./components/Note/AddEditFormModal').default);

// Graphs
Vue.component('apex-chart',VueApexCharts );
Vue.component('chart', require('./components/UI/Charts').default);

//Select
Vue.component('v-select', vSelect);

// Maps
Vue.component('l-map',LMap );
Vue.component('l-tile-layer',LTileLayer );
Vue.component('l-marker',LMarker );
Vue.component('l-circle-marker',LCircleMarker );
Vue.component('l-geojson',LGeoJson );
Vue.component('l-popup',LPopup );
Vue.component('maps', require('./components/UI/Map').default);

// Billing
Vue.component('billing-page', require('./components/Billing/BillingPage').default);
Vue.component('update-subscription', require('./components/Billing/UpdateSubscription').default);
Vue.component('update-payment-method', require('./components/Billing/UpdatePaymentMethod').default);

//Onboarding
Vue.component('onboarding-slides', require('./components/Onboarding/Slides').default);
